import React, { useState, useEffect } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import AutoComplete1 from "../../Utils/Select";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import {
  assignProspect,
  searchProspect,
} from "../../Redux/Actions/webAppActions";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
export const AssignProspect = (props) => {
  const [state, setState] = useState({
    assignValue: "",
    show: false,
    planCampaignName: "",
    assignedValue: "",
    snackBarOpen: false,
    vertical: "top",
    horizontal: "center",
    snackBarSeverty: "",
    snackBarMsg: "",
    list: [],
  });
  const campaignName = useSelector(
    (state1) => state1.campaignProspect.campaignNamesList
  );
  const prospectagentList = useSelector(
    // (state2) => state2.campaignProspect.agentList
    (state2) => state2.webApp.membershipAgentList
  );
  //const assignStatus = useSelector((state3) => state3.campaignProspect.status);
  const dispatch = useDispatch();
  const {
    assignValue,
    show,
    planCampaignName,
    assignedValue,
    snackBarOpen,
    vertical,
    horizontal,
    snackBarSeverty,
    snackBarMsg,
    list,
  } = state;
  const handleChange = (event) => {
    setState({ ...state, assignValue: event.target.value });
  };
  const handleOtherDropdown = (name) => async (event) => {
    let value = "";
    // if (name === "assignedValue") {
    //   //value = event.target ? event.target.label : event.label || event.value;
    //   value = event.target ? event.target.value : event.value || event.label;
    // } else {
     
    value = event.target ? event.target.value : event.value;
    // }
    setState({ ...state, [name]: value });
  };
  useEffect(() => {
    if (props.checkedList.length === 0) {
      setState({
        ...state,
        assignValue: "",
      });
    }
  }, [props.checkedList.length]);
  // useEffect(() => {
  //   let type = assignStatus.status === "OK" ? "success" : "error";
  //   console.log("clsassignStatus",assignStatus)
  //   if (assignStatus.status === "OK") {
  //     setState({
  //       ...state,
  //       show: false,
  //       // snackBarOpen: true,
  //       // vertical: "top",
  //       // horizontal: "center",
  //       // snackBarSeverty: type,
  //       // snackBarMsg: assignStatus.message,
  //     });
  //     dispatch(
  //       searchProspect({
  //         firstName: "",
  //         lastName: "",
  //         statusType: "",
  //         assignedTo: "",
  //         leadIdNbr: "",
  //         planCampaignId: "",
  //       })
  //     );
  //     props.searchHandler(assignStatus.message);
  //   } else {
  //     if (assignStatus.status !== "") {
  //       setState({
  //         ...state,
  //         snackBarOpen: true,
  //         vertical: "top",
  //         horizontal: "center",
  //         snackBarSeverty: type,
  //         snackBarMsg: assignStatus.errorMessage,
  //       });
  //     }
  //   }
  // }, [assignStatus]);
  const assignHandler = () => {
    if (assignValue === "campaign" && planCampaignName === "") {
      setState({
        ...state,
        snackBarOpen: true,
        vertical: "top",
        horizontal: "center",
        snackBarSeverty: "warning",
        snackBarMsg: "Please select campaign to assign.",
      });
      return;
    }
    if (assignValue === "agent" && assignedValue === "") {
      setState({
        ...state,
        snackBarOpen: true,
        vertical: "top",
        horizontal: "center",
        snackBarSeverty: "warning",
        snackBarMsg: "Please select agent to assign.",
      });
      return;
    }
    let value = assignValue === "campaign" ? planCampaignName : assignedValue;

    let payload = {
      type: assignValue,
      leadIdList: list,
      customerId: props.customerId,
      assignTo: value,
    };
    const res=dispatch(assignProspect(payload));
      
    res.then(function(value1){
      if(value1?.status==="OK" || value1?.data?.status==="OK" ){
        setState({
          ...state,
          show: false,
          // snackBarOpen: true,
          // vertical: "top",
          // horizontal: "center",
          // snackBarSeverty: "success",
          // snackBarMsg:value?.data,
        })
        props.searchHandler(value1?.data);
        dispatch(
          searchProspect({
            firstName: "",
            lastName: "",
            statusType: "",
            assignedTo: "",
            leadIdNbr: "",
            planCampaignId: "",
          })
        )
     
    }
      else{
        setState({
          snackBarOpen: true,
          vertical: "top",
          horizontal: "center",
          snackBarSeverty: "error",
          snackBarMsg:"Some error occured while saving",
        })
       
      }
         
        
    
  })};
  const openModal = () => {
    setState({
      ...state,
      show: true,
      planCampaignName: "",
      assignedValue: "",
      list: props.checkedList,
    });
  };
  return (
    <>
    
      <FormControl
        component="fieldset"
        disabled={props.checkedList.length <= 0 }
      >
        {/* <FormLabel component="legend">Assign Type:</FormLabel> */}
        <RadioGroup
          row
          aria-label="assign"
          name="assignValue"
          value={assignValue}
          onChange={handleChange}
        >
          {props.isSuperUser === true && (
            <>
              <FormControlLabel
                value="agent"
                control={<Radio color="primary" />}
                label="Agent"
              />
              <FormControlLabel
                value="campaign"
                control={<Radio color="primary" />}
                label="Campaign"
              />
              <button
                class="btn btn-dashboard-active mb-2 ml-2 btn-dashboard-active-color "
                onClick={openModal}
                disabled={
                  props.checkedList.length <= 0 ||
                  // || props.isAllchecked)
                  assignValue === ""
                }
              >
                Assign
              </button>
            </>
          )}
          <button
            data-toggle="modal"
            data-target="#prospectModal"
            class="btn btn-dashboard-active mb-2 ml-2 btn-dashboard-active-color "
            onClick={props.addProspect}
          >
            Add Prospect
          </button>
        </RadioGroup>
      </FormControl>
      <Modal
        show={show}
        onHide={() =>
          setState({ ...state, show: false, assignValue: "", list: [] })
        }
        size={"lg"}
        centered
        scrollable={true}
        // className="dashboard-zindex"
        backdrop="static"
      >
        <Modal.Header className="modal-header-background">
          <Modal.Title className={"piechart-header-position"}>
            Assign {assignValue}
          </Modal.Title>
          <button
            type="button"
            class="close"
            onClick={() =>
              setState({ ...state, show: false, assignValue: "", list: [] })
            }
          >
            &times;
          </button>
        </Modal.Header>

        <Modal.Body>
          <strong>Selected lead Ids: </strong>
          {list.map((x, index) =>
            list.length - 1 === index ? <>{`${x}`}</> : <>{`${x} ,`}</>
          )}
          <div>
            {assignValue === "campaign" ? (
              <span class="label-container">
                <label for="prospect_plan_campaign_name" class="labelprospect">
                  Plan Campaign Name <span class="mandatory-field">*</span>
                </label>
                <br />
                <AutoComplete1
                  field="plancampaignName"
                  dashboard="prospect"
                  height="7px !important"
                  width="236px"
                  error={
                    //props.prospectSaveFlag?
                    // planCampaignName === "" ||
                    planCampaignName === null || planCampaignName === undefined
                  }
                  handleChange={handleOtherDropdown("planCampaignName")}
                  options={campaignName}
                  value={
                    campaignName?.filter(
                      (data1) => data1?.value === planCampaignName
                    ).length !== 0
                      ? campaignName?.filter(
                          (data1) => data1?.value === planCampaignName
                        )[0]
                      : {
                          label: "select",
                          value: "",
                        }[0]
                  }
                  defaultValue={{ label: "select", value: "" }}
                  name="planCampaignName"
                />
              </span>
            ) : (
              <span class="label-container">
                <label for="prospect_assigned_to" class="labelprospect">
                  Assigned To <span class="mandatory-field">*</span>
                </label>
                <br />
                <AutoComplete1
                  dashboard="prospect"
                  height="7px !important"
                  width="236px"
                  field="assignedTo"
                  error={
                    // props.prospectSaveFlag?
                    assignedValue === ""
                  }
                  handleChange={handleOtherDropdown("assignedValue")}
                  options={
                    prospectagentList
                    //   ?.map((data) => ({
                    //   label: data?.value,
                    //   value: data?.label,
                    // }))
                  }
                  value={assignedValue}
                  //defaultValue={}
                  name="assignedTo"
                />
              </span>
            )}
            <button
              class="btn btn-dashboard-active mb-0 ml-2 mt-2"
              onClick={assignHandler}
              disabled={!(planCampaignName !== "" || assignValue !== "")}
            >
              Assign {assignValue}
            </button>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Snackbar
            open={snackBarOpen}
            autoHideDuration={6000}
            onClose={() => setState({ ...state, snackBarOpen: false })}
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
          >
            <Alert
              onClose={() => setState({ ...state, snackBarOpen: false })}
              severity={snackBarSeverty}
            >
              {snackBarMsg}
            </Alert>
          </Snackbar>
        </Modal.Footer>
      </Modal>
    </>
  );
};
